import { FC, ReactNode } from "react";
import { Stack } from "@mui/material";
import { useFlag } from "@unleash/proxy-client-react";
import { useAppSelector } from "@/store/hooks";
import { widgetSetupWidgetSyncedWithDashboardSelector } from "@/store/dashboards/selectors/setups/common/widgetSetupWidgetSyncedWithDashboardSelector";
import { WidgetDateRangeWithInheritanceSwitcher } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/date-range/WidgetDateRangeWithInheritanceSwitcher";

interface WidgetSetupDateRangeWithInheritanceProps {
  children: ReactNode;
  onChange(checked: boolean): void;
}

export const WidgetSetupDateRangeWithInheritance: FC<
  WidgetSetupDateRangeWithInheritanceProps
> = ({ onChange, children }) => {
  const enableDashboardDateAndCategoryFilter = useFlag(
    "EnableDashboardDateAndCategoryFilter",
  );

  const inheritDates = useAppSelector(
    widgetSetupWidgetSyncedWithDashboardSelector,
  );

  if (!enableDashboardDateAndCategoryFilter) {
    return children;
  }

  return (
    <Stack
      p={1.5}
      border={1}
      spacing={1.5}
      borderRadius={1}
      borderColor="grey.300"
    >
      <WidgetDateRangeWithInheritanceSwitcher
        inheritDates={inheritDates}
        onChange={onChange}
      />

      {!inheritDates && children}
    </Stack>
  );
};
